function explicitClientOnly(name) {
    throw new Error(`${name} is not available as a tarobase-server top-level auth operation. ` +
        'Use createWalletClient({ keypair }) and call the returned client method.');
}
export async function get(..._args) { explicitClientOnly('get'); }
export async function getMany(..._args) { explicitClientOnly('getMany'); }
export async function set(..._args) { explicitClientOnly('set'); }
export async function setMany(..._args) { explicitClientOnly('setMany'); }
export async function setFile(..._args) { explicitClientOnly('setFile'); }
export async function getFiles(..._args) { explicitClientOnly('getFiles'); }
export async function search(..._args) { explicitClientOnly('search'); }
export async function queryAggregate(..._args) { explicitClientOnly('queryAggregate'); }
export async function runQuery(..._args) { explicitClientOnly('runQuery'); }
export async function runQueryMany(..._args) { explicitClientOnly('runQueryMany'); }
export async function runExpression(..._args) { explicitClientOnly('runExpression'); }
export async function runExpressionMany(..._args) { explicitClientOnly('runExpressionMany'); }
export async function signMessage(..._args) { explicitClientOnly('signMessage'); }
export async function signTransaction(..._args) { explicitClientOnly('signTransaction'); }
export async function signAndSubmitTransaction(..._args) { explicitClientOnly('signAndSubmitTransaction'); }
export async function count(..._args) { explicitClientOnly('count'); }
export async function aggregate(..._args) { explicitClientOnly('aggregate'); }
export async function subscribe(..._args) { explicitClientOnly('subscribe'); }
export async function invokeFunction(..._args) { explicitClientOnly('invokeFunction'); }
export async function liveIntent(..._args) { explicitClientOnly('liveIntent'); }
export async function liveStatus(..._args) { explicitClientOnly('liveStatus'); }
export const functions = {
    invoke: async (..._args) => explicitClientOnly('functions.invoke'),
};
export const live = {
    intent: async (..._args) => explicitClientOnly('live.intent'),
    status: async (..._args) => explicitClientOnly('live.status'),
};
//# sourceMappingURL=explicit-client-only.js.map